'use client';

import { type Dispatch, type SetStateAction, useCallback, useMemo, useState } from 'react';

export function useToggle(defaultOn?: boolean): [boolean, () => void, Dispatch<SetStateAction<boolean>>] {
  const [on, setOn] = useState(Boolean(defaultOn));
  const toggle = useCallback(() => setOn((prevOn) => !prevOn), []);

  return useMemo(() => [on, toggle, setOn], [on, toggle]);
}
